import React from "react";

import GenericError from "../Errors/GenericError";

type PropType = {
  children: React.ReactNode;
  error?: Error;
};

type StatePropType = {
  error?: Error;
};

class ErrorBoundary extends React.Component<PropType, StatePropType> {
  static getDerivedStateFromError(error) {
    return { error };
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.state.error || this.props.error) {
      // eslint-disable-next-line no-console
      console.error(this.state.error || this.props.error);
      return <GenericError error={this.state.error || this.props.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
